module.exports = __webpack_public_path__ + "img/respect.37b153a9.jpg";